module.exports = __webpack_public_path__ + "static/media/gcdef_10056.1d22ce9c.ico";